/*eslint-disable */

import Multiselect from 'vue-multiselect'
import Vue from 'vue'
import {
  bus
} from '@/main';
import toast from '@/services/toast';

var $ = window.jQuery = require('jquery');


Vue.component('multiselect', Multiselect)
var newUserList

export default {
  name: 'update-group-info',
  components: {Multiselect},
  props: ['updateGroupInfoID'],
  data () {
    return {
      submitted:false,
      userList:null,
      userListResults:[], 
      options:[],
      optionsNew:[],
      topic:'',
      sentUserData:[],
      users:[],
      selectedUser:[],
      selectedUserID:[],
      uploadAttachmentName:'',
      file:null,
      selectedFile:null,
      groupAdminForUsers:[],
      madeAdminForUsers:[],
      sentGroupAdminId:[]
    }
  },
  computed: {

  },
  mounted () {
    document.body.classList.add('body_right_scroll_remove');
    this.getAllUserListMethod();
    this.getGroupDetailsByIdFun();
    newUserList = setInterval(()=>{
      if(this.options.length > 0 && this.selectedUserID.length > 0){
        const filtered = this.options.filter(item => !this.selectedUserID.includes(item.id));
        this.optionsNew = filtered
        if(this.optionsNew){
          clearInterval(newUserList)
        }
      }
    },100)
  },
  methods: {
    getGroupDetailsByIdAgainFun(updateGroupInfoID){
      this.$store.dispatch('getGroupChatDetailsByIdFun', { id: updateGroupInfoID }).then((res)=>{
        bus.$emit('updateGroupInfoDataBus', res.data.data)
      })
    },
    getGroupDetailsByIdFun(){
      this.$store.dispatch('getGroupChatDetailsByIdFun', { id: this.updateGroupInfoID }).then((res)=>{
        for(var i = 0; i < res.data.data.users.length; i++){
          this.selectedUserID.push(res.data.data.users[i].user.id)
          this.groupAdminForUsers.push({first_name:res.data.data.users[i].user.first_name,last_name:res.data.data.users[i].user.last_name,email:res.data.data.users[i].user.email, id : res.data.data.users[i].user.id})
        }
        if(res.data.data.group_image){
          this.uploadAttachmentName = res.data.data.group_image.split('/')[5].split('?')[0]
        }
      })
    },
    handleAttachmentUpload(event) {
      if (event.target.files && event.target.files.length > 0) {
        this.file = event.target.files[0];
        this.files = this.$refs.file.files[0];
        this.uploadAttachmentName = this.files.name
      }  else {
        this.uploadAttachmentName = '';
      }
    },
    getGroupRoomListAgain(){
      this.$store.dispatch('getAllLeftChatListDetailsFun');
    },
    getAllUserListMethod() {
     this.$store.dispatch('isConditionalListOfAllUsersFun').then((res) => {
       this.userList = res.data.data;
       if(this.userList){
         this.userListResults = this.userList;
         for(var i = 0; i < this.userListResults.length; i++){
            this.options.push({first_name:this.userListResults[i].first_name,last_name:this.userListResults[i].last_name,email:this.userListResults[i].email, id : this.userListResults[i].id});
         }
       }
     })
    },
    updateGroupChatBeforeSubmitMethod(){
      this.$validator.validateAll().then((result) => {
        if(result){
          this.submitted =  true
          for(var i = 0; i < this.users.length; i++){
            this.sentUserData.push(this.users[i].id)
          }
          var data = {
            users:this.sentUserData
          }
          this.$store.dispatch('updateGroupChatDetailsFun', {data:{data:data,id:this.updateGroupInfoID}})
            .then((res) => { 
              toast.success(res.data.msg);
              this.getGroupDetailsByIdAgainFun(this.updateGroupInfoID);
              this.updateGroupPopupDisabledFun();
              this.submitted =  false
            }).catch((err) => {
              toast.error(err.data.msg);
              this.submitted =  false
            })
          return;
        }
      })
    },
    updateGroupPopupDisabledFun(){
      document.body.classList.remove('body_right_scroll_remove');
      bus.$emit('updateGroupInfoPopupStateBus', false);
      clearInterval(newUserList);
    }
  },
  watch:{
  }
}


